import EventEmitter from 'events';

type ListenerKey =
  | 'cartView'
  | 'addToCart'
  | 'removeFromCart'
  | 'promotionImpression'
  | 'promotionClick'
  | 'productClick'
  | 'variantClick'
  | 'productDetailView'
  | 'checkout'
  | 'purchase'
  | 'productImpression'
  | 'variantImpression';

type Listener = {
  [key in ListenerKey]: (...args: any[]) => void;
};

export class Tracker extends EventEmitter {
  /**
   *   An array containing objects where each key is the name of the event to be emitted
   *   and the value is a function that will be called on each event with the provided data
   */
  constructor(listeners: Listener[]) {
    super();
    // Extract the method names of the listeners, the method names will create event listeners
    for (const listener of listeners) {
      for (const [event, handler] of Object.entries(listener)) {
        this.on(event, handler);
      }
    }
  }
}
